import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API_BASE } from "../DataContext";

const TOKEN_KEY = "baishalii_vendor_token";
const VendorAuthCtx = createContext(null);

export const useVendorAuth = () => useContext(VendorAuthCtx);

export function VendorAuthProvider({ children }) {
  const [token, setTokenState] = useState(() => sessionStorage.getItem(TOKEN_KEY) || "");
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = useCallback((t) => {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
    setTokenState(t || "");
  }, []);

  const logout = useCallback(() => {
    setToken("");
    setVendor(null);
  }, [setToken]);

  const login = useCallback(async (email, password) => {
    const r = await fetch(`${API_BASE}/api/vendor/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.detail || "Login failed");
    }
    const data = await r.json();
    setToken(data.token);
    setVendor(data.vendor);
    return data.vendor;
  }, [setToken]);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/vendor/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(setVendor)
      .catch(() => setToken(""))
      .finally(() => setLoading(false));
  }, [token, setToken]);

  return (
    <VendorAuthCtx.Provider value={{ token, vendor, loading, login, logout }}>
      {children}
    </VendorAuthCtx.Provider>
  );
}

export const vendorFetch = (token) => (path, opts = {}) =>
  fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      ...(opts.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
